export const PROVIDER_OPTIONS = [
  { label: "All" },
  { label: "Duplicate" },
  { label: "Archive" },
  { label: "Move" },
  { label: "Delete" },
];

export const SORT_BY_OPTIONS = [
  { label: "Popular" },
  { label: "New Releases" },
  { label: "Alphabetical" },
  { label: "Alphabetical Z-A" },
  { label: "Prize Pool" },
];

export const COLLECTION_OPTIONS = [
  { label: "All" },
  { label: "Duplicate" },
  { label: "Archive" },
  { label: "Move" },
  { label: "Delete" },
];

export const TRAITS_OPTIONS = [
  { label: "All" },
  { label: "Duplicate" },
  { label: "Archive" },
  { label: "Move" },
  { label: "Delete" },
];

export const MY_BETS_OPTIONS = [
  { label: "Today" },
  { label: "For Week" },
  { label: "For Month" },
  { label: "Last Bets" },
  { label: "Custom" },
];

export const ODDS_FORMAT_OPTIONS = [
  { label: "European" },
  { label: "American" },
  { label: "Hong Kong" },
  { label: "Malaysian" },
  { label: "Fractional" },
];
